import React, { useState } from "react";
import { Dropdown, Offcanvas } from "react-bootstrap";
import Custombutton from "../../../utils/Custombutton";
import { Link, useNavigate, useLocation } from "react-router-dom";

const Header = () => {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleSectionClick = (sectionId) => {
    if (location.pathname === "/") {
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      navigate("/", { state: { sectionId } });
    }
    handleClose();
  };

  React.useEffect(() => {
    if (location.state?.sectionId) {
      const section = document.getElementById(location.state.sectionId);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  return (
    <div className="nav-bar d-flex justify-content-between align-items-center">
      <Link to="/">
        <img className="logo" src="./assets/images/cosmic.svg" alt="cosmic" />
      </Link>
      <div
        style={{
          cursor: "pointer",
        }}
        onClick={handleShow}
        className="d-xl-none"
      >
        <img src="./assets/images/menu.png" alt="menu" />
      </div>

      <Offcanvas show={show} onHide={handleClose}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            {" "}
            <img
              className="w-50"
              src="./assets/images/cosmic.svg"
              alt="cosmic"
            />
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <ul>
            <li
              className="mx-2"
              onClick={() => handleSectionClick("home")}
              onHide={handleClose}
            >
              Home
            </li>

            <li
              className="mx-2"
              onClick={() => handleSectionClick("about")}
              onHide={handleClose}
            >
              About
            </li>
            <li
              className="mx-2"
              onClick={() => handleSectionClick("ecosystem")}
              onHide={handleClose}
            >
              Ecosystem
            </li>
            <li
              className="mx-2"
              onClick={() => handleSectionClick("team")}
              onHide={handleClose}
            >
              Team
            </li>
            <li
              className="mx-2"
              onClick={() => handleSectionClick("contact")}
              onHide={handleClose}
            >
              Let's Talk
            </li>
          </ul>
          <div className="d-flex flex-column align-items-start gap-3 mt-3">
            <Dropdown className="p-0">
              <Dropdown.Toggle className="p-0 bg-none outline-0 border-0">
                <Custombutton label={"DOWNLOADs"} className={"btn-bg px-5"} />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item href="/download/windows">
                  <img src="/assets/images/window-drop.png" alt="window" />{" "}
                  Windows
                </Dropdown.Item>
                <Dropdown.Item href="https://apps.apple.com/us/app/cosmic-vpn/id6664064415">
                  <img src="/assets/images/mac-drop.png" alt="window" /> macOS
                </Dropdown.Item>
                <Dropdown.Item href="https://play.google.com/store/apps/details?id=com.cosmic.dvpn">
                  <img src="/assets/images/linux-drop.png" alt="window" /> Android
                </Dropdown.Item>
                <Dropdown.Item href="https://apps.apple.com/us/app/cosmic-vpn/id6664064415">
                  <img src="/assets/images/ios-drop.png" alt="window" /> IOS
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            {/* <Custombutton label={"Buy"} className={"btn-bg px-5"} /> */}

            <Dropdown>
              <Dropdown.Toggle className="p-0 bg-none outline-0 border-0">
                <Custombutton label={"Buy"} className={"btn-bg px-5"} />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item href="https://app.uniswap.org/swap?outputCurrency=0x55A05Cf8898dd1c582eef939Df645d5D235C6f74&chain=ethereum" className="d-flex align-items-center gap-2">
                  <img src="/assets/images/uniswap.png" alt="uniswap" />{" "}
                  Uniswap
                </Dropdown.Item>
                <Dropdown.Item href="https://www.mexc.com/exchange/COSMIC_USDT" className="d-flex align-items-center gap-2">
                  <img src="/assets/images/mexc.png" alt="mexc" />
                  MEXC
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
      <div className="d-none d-xl-flex gap-4 align-items-center">
        <ul className="d-none d-xl-flex mb-0">
          <li className="mx-2" onClick={() => handleSectionClick("home")}>
            Home
          </li>

          <li className="mx-2" onClick={() => handleSectionClick("about")}>
            About
          </li>
          <li className="mx-2" onClick={() => handleSectionClick("ecosystem")}>
            Ecosystem
          </li>
          <li className="mx-2" onClick={() => handleSectionClick("team")}>
            Team
          </li>
          <li className="mx-2" onClick={() => handleSectionClick("contact")}>
            Let's Talk
          </li>
        </ul>
        <div className="d-none d-xl-flex align-items-center gap-4">
          <Dropdown>
            <Dropdown.Toggle className="p-0 bg-none outline-0 border-0">
              <Custombutton label={"DOWNLOADs"} className={"btn-bg px-5"} />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item href="/download/windows">
                <img src="/assets/images/window-drop.png" alt="window" />{" "}
                Windows
              </Dropdown.Item>
              <Dropdown.Item href="https://apps.apple.com/us/app/cosmic-vpn/id6664064415">
                <img src="/assets/images/mac-drop.png" alt="window" /> macOS
              </Dropdown.Item>
              <Dropdown.Item href="https://play.google.com/store/apps/details?id=com.cosmic.dvpn">
                <img src="/assets/images/linux-drop.png" alt="window" /> Android
              </Dropdown.Item>
              <Dropdown.Item href="https://apps.apple.com/us/app/cosmic-vpn/id6664064415">
                <img src="/assets/images/ios-drop.png" alt="window" /> IOS
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          <Dropdown>
            <Dropdown.Toggle className="p-0 bg-none outline-0 border-0">
              <Custombutton label={"Buy"} className={"btn-bg px-5"} />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item href="https://app.uniswap.org/swap?outputCurrency=0x55A05Cf8898dd1c582eef939Df645d5D235C6f74&chain=ethereum" className="d-flex align-items-center gap-2">
                <img src="/assets/images/uniswap.png" alt="uniswap" />{" "}
                Uniswap
              </Dropdown.Item>
              <Dropdown.Item href="https://www.mexc.com/exchange/COSMIC_USDT" className="d-flex align-items-center gap-2">
                <img src="/assets/images/mexc.png" alt="mexc" />
                MEXC
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
    </div>
  );
};

export default Header;
